export default import.meta.ROLLDOWN_FILE_URL_hd_BXCx25dCCiTFVAMV3Fg